import { map_type_to_link } from "../../../utils/mapping";

const PageAttachment = ({attachment}) => {
  const attachment_link = map_type_to_link(attachment.attachment_type, attachment.attachment_id)
  const truncate = (input) =>
    input?.length > 85 ? `${input.substring(0, 81)}...` : input;

  return(
    <div className="post-page-attachment">
      <a href={attachment_link}>
      <div className="post-page-attachment-image">
        <img src={attachment.image_main.src}/>
      </div>
      <div className="post-page-attachment-content">
        <div className="post-page-attachment-title">
          <span>{attachment.title}</span>
        </div>
        <div className="post-page-attachment-body">
          {truncate(attachment.body)}
        </div>
      </div>
      </a>
    </div>
  )
}

export default PageAttachment;